import React from 'react';
import PropTypes from 'prop-types';
import { Emoji, Heading } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);
export var RenderSuccess = function RenderSuccess(_ref) {
  var texts = _ref.texts;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('successEmoji'),
    "data-t-id": "components-RenderSuccess"
  }, /*#__PURE__*/React.createElement(Emoji, {
    className: cx('emoji'),
    name: "statusOk"
  })), /*#__PURE__*/React.createElement(Heading, {
    className: cx('popupHeading', 'success'),
    level: 1
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: texts.successTitle
    },
    "data-t-id": "components-RenderSuccess"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('successContent'),
    dangerouslySetInnerHTML: {
      __html: texts.sucessContent
    }
  }));
};
RenderSuccess.propTypes = process.env.NODE_ENV !== "production" ? {
  texts: PropTypes.shape({
    successTitle: PropTypes.string,
    sucessContent: PropTypes.string
  })
} : {};